export const ActionTypes = {
    setApplications: 'application/SET_APPLICATIONS',
    addApplications: 'application/ADD_APPLICATIONS',
    setLoadingApplications: 'application/SET_LOADING_APPLICATIONS',
    setApplicationsPage: 'application/SET_APPLICATIONS_PAGE',
    setApplication: 'application/SET_APPLICATION',
    setLoadingApplication: 'application/SET_LOADING_APPLICATION',
    setApplicationNotFound: 'application/SET_APPLICATION_NOT_FOUND',
    setApplicationStats: 'application/SET_APPLICATION_STATS',
    setLoadingApplicationStats: 'application/SET_LOADING_APPLICATION_STATS',
    setApplicationsFilters: 'application/SET_APPLICATION_FILTERS',
    updateApplicationStatusLocally: 'application/UPDATE_APPLICATION_STATUS_LOCALLY',
    setDailyApplicationCount: 'application/SET_DAILY_APPLICATION_COUNT',
}